import React from 'react';
import { Breadcrumb } from 'semantic-ui-react';
import _capitalize from 'lodash/capitalize';
import _isEmpty from 'lodash/isEmpty';
import _isNil from 'lodash/isNil';
import InternalLink from '../../../../atoms/InternalLink/InternalLink';
import Icon from '../../../../modules/foundation/components/Icon/Icon';
import { cleanSlug } from '../../../../modules/navigation/services/slugs';
import './BlogPostBreadcrumbs.less';
var defaultProps = {
  linkIcon: null,
  dividerIcon: 'right chevron',
  dividerContent: null
};
export default function BlogPostBreadcrumbs(_ref) {
  var title = _ref.title,
    blogRootSlug = _ref.blogRootSlug,
    linkIcon = _ref.linkIcon,
    dividerIcon = _ref.dividerIcon,
    dividerContent = _ref.dividerContent;
  var cleanedRootSlug = cleanSlug(blogRootSlug);
  return /*#__PURE__*/React.createElement(Breadcrumb, {
    className: "blog-post-breadcrumbs"
  }, /*#__PURE__*/React.createElement(Breadcrumb.Section, {
    link: true,
    as: InternalLink,
    to: blogRootSlug
  }, /*#__PURE__*/React.createElement(React.Fragment, null, !_isNil(linkIcon) && /*#__PURE__*/React.createElement(Icon, {
    iconName: linkIcon
  }), /*#__PURE__*/React.createElement("span", null, _capitalize(cleanedRootSlug)))), /*#__PURE__*/React.createElement(Breadcrumb.Divider, {
    icon: _isEmpty(dividerContent) ? dividerIcon : null,
    content: dividerContent
  }), /*#__PURE__*/React.createElement(Breadcrumb.Section, null, title));
}
BlogPostBreadcrumbs.defaultProps = defaultProps;